import { loadStripe } from "@stripe/stripe-js"
import { NextRouter } from "next/router"
import { InitializePaymentSessionOutputType } from "../../../api/backend/backend-api"
import { typNoPayPagePath } from "../../../root/routing/urls"

const redirectToPayPal = (paymentData: InitializePaymentSessionOutputType) => {
  if (!paymentData.paymentPayload) {
    throw new Error("Missing payload data")
  }

  const payload = JSON.parse(paymentData.paymentPayload)
  const redirectUrl = payload.links.find((x: any) => x.rel === "approve")
  window.location.href = redirectUrl.href
}

const redirectToStripe = async (
  paymentData: InitializePaymentSessionOutputType
) => {
  if (!paymentData.paymentPayload) {
    throw new Error("Missing payload data")
  }
  const payload = JSON.parse(paymentData.paymentPayload)
  const stripe = await loadStripe(payload.metadata.publicKey)
  await stripe?.redirectToCheckout({
    sessionId: payload.id,
  })
}
const redirectToKlarna = async (
  paymentData: InitializePaymentSessionOutputType
) => {
  if (!paymentData.paymentPayload) {
    throw new Error("Missing payload data")
  }
  const payload = JSON.parse(paymentData.paymentPayload)
  window.location.href = payload.redirect_url
}
const redirectToSatispay = async (
  paymentData: InitializePaymentSessionOutputType
) => {
  if (!paymentData.paymentPayload) {
    throw new Error("Missing payload data")
  }
  const payload = JSON.parse(paymentData.paymentPayload)
  window.location.href = payload.redirect_url
}

export const redirectToPayment = (
  payment: InitializePaymentSessionOutputType
) => {
  switch (payment.providerId) {
    case "stripe":
      redirectToStripe(payment)
      break
    case "paypal":
      redirectToPayPal(payment)
      break
    case "klarna":
      redirectToKlarna(payment)
      break
    case "satispay":
      redirectToSatispay(payment)
      break
    default:
      throw new Error(`Invalid provider ${payment.providerId}`)
  }
}

export const redirectToNoPaymentTyp = (basketId: string, router: NextRouter) =>
  router.push(typNoPayPagePath(basketId))
